import React, { useState } from "react";
import { Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function CopyLockedURLButton({ pattern, searchParams }) {
   const [copied, setCopied] = useState(false);

   const handleCopy = () => {
      // Build fullscreen URL with pattern and all query params
      const queryString = searchParams.toString();
      const fullscreenUrl = `/fullscreen/${pattern}${queryString ? '?' + queryString : ''}`;
      const fullUrl = window.location.origin + fullscreenUrl;
      
      navigator.clipboard.writeText(fullUrl).then(() => {
         setCopied(true);
         setTimeout(() => setCopied(false), 2000);
      }).catch(err => {
         console.error('Failed to copy URL:', err);
         // Fallback for older browsers
         const textArea = document.createElement('textarea');
         textArea.value = fullUrl;
         document.body.appendChild(textArea);
         textArea.select();
         try {
            document.execCommand('copy');
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
         } catch (err) {
            console.error('Fallback copy failed:', err);
         }
         document.body.removeChild(textArea);
      });
   };

   return (
      <Button
         variant="outlined"
         size="small"
         onClick={handleCopy}
         startIcon={<LockIcon />}
         endIcon={<ContentCopyIcon />}
         sx={{ ml: 2 }}
      >
         {copied ? "Copied!" : "Copy Locked URL"}
      </Button>
   );
}
